import { render, staticRenderFns } from "./Navigator.vue?vue&type=template&id=264185ca&scoped=true&"
import script from "./Navigator.vue?vue&type=script&lang=js&"
export * from "./Navigator.vue?vue&type=script&lang=js&"
import style0 from "./Navigator.vue?vue&type=style&index=0&id=264185ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264185ca",
  null
  
)

export default component.exports